<div>
    <div>
        <div style="display: block">
            <canvas baseChart
                    [datasets]="barChartData"
                    [labels]="barChartLabels"
                    [options]="barChartOptions"
                    [plugins]="barChartPlugins"
                    [legend]="barChartLegend"
                    [type]="barChartType">
            </canvas>
        </div>
        <!--<button mat-button mat-raised-button color="primary" (click)="randomize()">Update</button>-->
    </div>
</div>